import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		tooltip: {
			maxWidth: 200,
			zIndex: 3,
			position: 'absolute',
			fontWeight: 400,
			background: '#1B1A7C',
			borderRadius: '4px',
			padding: '6px 12px',
			fontSize: '12px',
			color: '#fff',
			'&::before': {
				content: "''",
				width: 0,
				height: 0,
				borderWidth: '8px',
				borderStyle: 'solid',
				borderColor: 'transparent #1B1A7C transparent transparent',
				position: 'absolute',
				top: '5px',
				left: '-15px'
			},
		},
		tooltipInfo: {
			marginTop: '5px',
			marginBottom: '0px !important',
			fontWeight: 600,
		},
		container: {
			marginTop: theme.spacing(2),
			flexGrow: 1,
		},
		activeContainer: {
			position: 'relative',
			// margin: '0 -15px',
			margin: `${theme.spacing(1)}px 0 0 0`,
			padding: 0,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
			flex: 1,
			alignSelf: 'stretch',
			cursor: 'pointer',
			'& .fr-box': {
				display: 'flex',
				flexDirection: 'column',
				alignSelf: 'stretch',
				// height: '100%',
				flexGrow: 1,
				'.show-placeholder': {
					'> .fr-element > p': {
					}
				},
				'& .fr-element': {
					paddingTop: 0,
					'& > p': {
						color: '#414141',
						fontSize: '16px !important',
					}
				},
				'& .fr-placeholder': {
					fontSize: '16px !important',
					color: theme.palette.grey[300],
					opacity: '1 !important',
					fontWeight: 500,
					lineHeight: '22px !important'
				},
				'& > .fr-toolbar': {
					border: 'none',
					boxShadow: 'none',
					background: 'transparent',
				},
				'& > .fr-wrapper': {
					flexGrow: 1,
					boxShadow: 'none!important',
					background: 'transparent',
				},
			},
			[theme.breakpoints.down('sm')]: {
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				background: '#ffffff',
				zIndex: 100,
			},
		},
		buttonsContainer: {
			flex: 1,
			alignSelf: 'stretch',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			maxHeight: 48,
			'& > button': {
				flex: 1,
				height: theme.spacing(6),
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				color: '#ffffff',
				fontSize: 18,
			},
		},
		cancelButton: {
			fontWeight: 500,
			backgroundColor: theme.palette.grey[300],
		},
		saveButton: {
			fontWeight: 700,
			backgroundColor: theme.palette.secondary.main,
		},
		preview: {
			padding: 16,
			// position: 'absolute',
			// top: 0,
			// right: 0,
			// bottom: 0,
			// left: 0,
			overflow: 'auto',
			[theme.breakpoints.down('sm')]: {
				padding: 8,
			},
		},
		error: {
			'& .fr-placeholder': {
				color: 'rgba(255,0,0,0.5)!important',
			},
			'& $preview': {
				color: 'rgba(255,0,0,0.5)!important',
			},
		},
		froalaEditorWrapper: {
			width: '100%',
			height: '100%',
		},
	})
